import React from 'react';
import 'swiper/scss';
import './style.scss';
import { API_OwnNft } from 'shared';
import OwnNftsCarouselSwiper from './swiper';
import NftIcon from '../../../../general/nft/icon';
import clsx from 'clsx';

interface Props {
  nfts: API_OwnNft[];
  activeIndex: number;
  setActiveIndex: (newIndex: number) => void;
  horizontal?: boolean;
}

const FightPickNftCarousel = ({
  nfts,
  activeIndex,
  setActiveIndex,
  horizontal
}: Props) => {
  return (
    <div className={clsx('own-nfts-carousel', horizontal && 'horizontal')}>
      <h4 className='carousel-heading body-2'>YOUR NIFTY GANG:</h4>
      {nfts.length >= 2 && (
        <OwnNftsCarouselSwiper
          nfts={nfts}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          horizontal={horizontal}
        />
      )}
      {nfts.length === 1 && <NftIcon data={nfts[0]} />}
    </div>
  );
};

export default FightPickNftCarousel;
